module.exports = __webpack_public_path__ + "img/01-icon.d468addf.png";